import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/de";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("de");

export const BERLIN = "Europe/Berlin";

export function toBerlin(input) {
    return dayjs(input).tz(BERLIN);
}

export function formatDate(input) {
    if (!input) return "-";
    return toBerlin(input).format("DD.MM.YYYY");
}

export function formatTime(input) {
    if (!input) return "-";
    return toBerlin(input).format("HH:mm");
}

export function formatDateTime(input) {
    if (!input) return "-";
    return toBerlin(input).format("DD.MM.YYYY, HH:mm");
}

export function todayBerlin() {
    return dayjs().tz(BERLIN).format("YYYY-MM-DD");
}

export function nowBerlin() {
    return dayjs().tz(BERLIN);
}

export function formatMinutesAsHours(minutes) {
    const m = Number(minutes || 0);
    const h = m / 60;
    return h.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatHoursShort(minutes) {
    const m = Number(minutes || 0);
    const hours = Math.floor(m / 60);
    const rem = Math.round(m % 60);
    return `${hours}h ${String(rem).padStart(2, "0")}m`;
}

export function formatDuration(seconds) {
    const total = Math.max(0, Math.floor(Number(seconds || 0)));
    const h = Math.floor(total / 3600);
    const min = Math.floor((total % 3600) / 60);
    const s = total % 60;
    return `${String(h).padStart(2, "0")}:${String(min).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

export function formatCurrency(value) {
    return Number(value || 0).toLocaleString("de-DE", {
        style: "currency", currency: "EUR",
    });
}

/** Convert local (Berlin) datetime-local input string to UTC ISO. */
export function berlinInputToUTC(input) {
    if (!input) return null;
    return dayjs.tz(input, BERLIN).utc().toISOString();
}

/** Convert UTC ISO to Berlin datetime-local input value (YYYY-MM-DDTHH:mm). */
export function utcToBerlinInput(iso) {
    if (!iso) return "";
    return toBerlin(iso).format("YYYY-MM-DDTHH:mm");
}
